export default __webpack_public_path__ + "static/media/celo.f572f816.svg";